__turbopack_context__.v({
  "subtitle": "bC4IXG_subtitle",
  "title": "bC4IXG_title",
});
